import emily from '../images/image-emily.jpg';
import jennie from '../images/image-jennie.jpg';
import thomas from '../images/image-thomas.jpg';
import Testimonial from './Testimonial';
function Testimonials(){
    const info=[
        {
            src:emily,
            txt:`We put our trust in Sunnyside and they delivered, making sure our needs were met and deadlines were always hit.`,
            name:`Emily R.`,
            title:`Marketing Director`
        },
        {
            src:thomas,
            txt:`Sunnyside’s enthusiasm coupled with their keen interest in our brand’s success made it a satisfying and enjoyable experience.`,
            name:`Thomas S.`,
            title:`Chief Operating Officer`
        },
        {
            src:jennie,
            txt:`Incredible end result! Our sales increased over 400% when we worked with Sunnyside. Highly recommended!`,
            name:`Jeannie F.`,
            title:`Bussiness Owner`
        }
      
    ]
    return (
        <section className="testimonials">
            <h3 className="fs-heading-light fw-bold txt-gray-light txtCtr testimonials--heading">Client Testimonials</h3>
            <div className="testimonials--display">
                <Testimonial 
                src={info[0].src}
                txt={info[0].txt}
                name={info[0].name}
                title={info[0].title}
                 />
                <Testimonial 
                src={info[1].src}
                txt={info[1].txt}
                name={info[1].name}
                title={info[1].title}
                 />
                <Testimonial 
                src={info[2].src}
                txt={info[2].txt}
                name={info[2].name}
                title={info[2].title}
                 />
                  
            </div>
        </section>
    )
}
export default Testimonials;